import { ProjectCreateDto, ProjectDetailsDto, ProjectListItemDto, ProjectUpdateDto } from 'types/projects';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIProjectsSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['ProjectListItems', 'Project'] }).injectEndpoints({
    endpoints: (builder) => ({
        getProjectById: builder.query<ProjectDetailsDto, string>({
            query: (id) => `/v1/projects/${id}`,
            keepUnusedDataFor: 0,
            providesTags: (_result, _error, id) => [{ type: 'Project', id }],
        }),
        getProjectsWithFilters: accumulatedQueryWithFilters<ProjectListItemDto>(builder, '/v1/projects', {
            providesTags: ['ProjectListItems'],
        }),
        addProject: builder.mutation<ProjectDetailsDto, ProjectCreateDto>({
            query: (body) => ({
                url: `/v1/projects`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ProjectListItems'],
        }),
        updateProject: builder.mutation<ProjectDetailsDto, ProjectUpdateDto>({
            query: ({ id, ...body }) => ({
                url: `/v1/projects/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['ProjectListItems'],
            async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
                const { data: updatedRecord } = await queryFulfilled;
                dispatch(APIProjectsSlice.util.updateQueryData('getProjectById', id.toString(), () => updatedRecord));
            },
        }),
        deleteProject: builder.mutation<boolean, { id: string }>({
            query: ({ id }) => ({
                url: `/v1/projects/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ProjectListItems'],
        }),
        removeMatterFromProject: builder.mutation<void, { projectId: number; matterId: number }>({
            query: ({ projectId, matterId }) => ({
                url: `/v1/projects/${projectId}/matters/${matterId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ProjectListItems'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetProjectByIdQuery,
    useLazyGetProjectsWithFiltersQuery,
    useAddProjectMutation,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
    useRemoveMatterFromProjectMutation,
} = APIProjectsSlice;
